import axios from 'axios'
import config from '../../../config'

let KetonesApi = {
  updateKetonesTracking(model) {
    return axios.put(config.apiUrl + 'tracking/ketones/', model);
  },
  getKetonesTrackingDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/ketones/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },
  deleteKetonesTracking(progressId, trackingId) {
    return axios.delete(config.apiUrl + 'tracking/ketones/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    })
  },
  getKetonesTrackingCard() {
    return axios.get(config.apiUrl + 'tracking/ketones/card/?requestFrom=web');
  },
  postKetonesTracking(model) {
    return axios.post(config.apiUrl + 'tracking/ketones/', model);
  }
};
export default KetonesApi



// WEBPACK FOOTER //
// ./src/api/Tracking/Ketones/index.js